import Skeleton from '@mui/material/Skeleton';
import styles from './Table.module.scss';
import { useId } from '../../../../lib/hooks/useId';
import { tableIds } from '../../../../lib/tests/testIds';

export const TableTitleRowSkeleton = ({ withTitleOrSearch }: { withTitleOrSearch: boolean }) => {
  return (
    <>
      {withTitleOrSearch && <Skeleton className={styles.tableSearchSkeleton} />}
      <Skeleton className={styles.tableSortSkeleton} />
    </>
  );
};

export const TableSkeleton = ({ length }: { length: number }) => {
  const skeletonRowId = useId('skeleton-table-row-');
  const skeletonRows = Array.from({ length }, (_, i) => `${skeletonRowId}${i}`);

  return (
    <div data-testid={tableIds.skeletonRows}>
      {skeletonRows.map(id => (
        <Skeleton key={id} className={styles.tableSkeletonRow} />
      ))}
    </div>
  );
};
